import React, { useState, useEffect } from "react";
import { Card } from "baseui/card";
import { Button } from "baseui/button";
import HeadingSection from "../components/Heading";
import { UserContext } from '../App';
import { useNavigate } from "react-router-dom";
import stripeImg from '../assets/stripe.png';
import adyenImg from '../assets/adtyen.png';
import checkoutImg from '../assets/checkout.png';
import authImg from '../assets/auth.png';
import { updateMerchantAccount } from "../utils/data";
import { baseUrl, getHeader } from "../utils/consts";
import ArrowRight from 'baseui/icon/arrow-right';
import { useSnackbar } from 'baseui/snackbar';
import { Notification, KIND as NKIND } from "baseui/notification";

const PaymentGatewaySelectPage = () => {
  let { uid, name, selectedPgs, selectedPg, setValue } = React.useContext(UserContext);
  let navigate = useNavigate();
  const { enqueue } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [pgList, setPgList] = useState([...selectedPgs]);

  useEffect(() => {
    console.log(selectedPgs)
    setPgList([...selectedPgs])
  }, [selectedPgs])

  const setMessage = (message, bgColor) => {
    enqueue({
      message: message,
      overrides: {
        Root: { style: { width: 'auto', backgroundColor: bgColor } },
      }
    })
  }

  let updateMerchantPaymentGateway = () => {
    setIsLoading(true)
    fetch(`${baseUrl}/accounts/${uid}`, {
      method: 'POST',
      headers: getHeader("test_admin"),
      body: updateMerchantAccount(name, uid, [selectedPg ? selectedPg.toLowerCase() : ""])
    }).then((res) => {
      if (res.status == 200) {
        setIsLoading(false)
        navigate("/test-payment");
      } else {
        setIsLoading(false)
        res.text().then(val =>
          console.log("Network Error:-", JSON.parse(val).error.message)
        )
      }
    }).catch(err => {
      console.log("ERROR:- ", err.message)
      setMessage("There was an error!, Could't Update The Account", "red")
      setIsLoading(false)
    });
  }

  const paymentGateways = [
    [<div className="w-5 h-5 mt-1" >
      <img src={stripeImg} alt="" />
    </div>, "Stripe"],
    [<div className="w-5 h-5 mt-1" style={{ scale: "1.5" }} >
      <img src={adyenImg} alt="" />
    </div>, "Adyen"],
    [<div className="w-5 h-5 mt-1" >
      <img src={checkoutImg} style={{ scale: "2" }} alt="" />
    </div>, "Checkout"],
    [<div className="w-5 h-5 mt-1" >
      <img src={authImg} style={{ scale: "1.2" }} alt="" />
    </div>, "Authorizedotnet"]
  ].filter(item => pgList.includes(item[1]))

  return (
    <div className='w-full max-w-xl mx-auto' >
      <Card>
        <div className='p-5' >
          <HeadingSection iconEnabled={true} headerClass="mb-10" title={"Select a Connector"} backUrl={"/account-retrive"} />
          <div className="flex flex-col mb-5" >
            {
              paymentGateways.map((item, index) => (
                <div key={index} onClick={() => setValue("selectedPg", item[1])} className={`border-2 w-full flex align-middle  px-3 py-2 my-2 bg-gray-50 ${selectedPg === item[1] ? "border-black bg-gray-100" : ""} hover:bg-gray-100 cursor-pointer rounded-lg`}  >
                  {item[0]}
                  <div className="font-medium ml-2 text-xl" >
                    {item[1]}
                  </div>
                </div>
              ))
            }
          </div>
          <Notification kind={NKIND.warning} overrides={{
            Body: { style: { width: 'auto', marginLeft: "0", marginRight: "0" } },
          }}>
            {() => (<><div className='mb-1' >
              <b>Note:</b> Priority logic coming soon
            </div>
            </>)}
          </Notification>
          <Button className='mt-10' isLoading={isLoading} style={{ width: "100%" }} onClick={updateMerchantPaymentGateway} endEnhancer={() => <ArrowRight size={24} />}  >Next</Button>
        </div>
      </Card>
    </div>
  )
}

export default PaymentGatewaySelectPage